import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import HeadlineWidget from "../../Widgets/HeadlineWidget/HeadlineWidgetClass";
import SectionContentWidget from "../../Widgets/SectionContentWidget/SectionContentWidgetClass";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("ContactPage", {
  title: "Contact Page",
  hideInSelectionDialogs: true,
  thumbnailForContent: (obj) => obj.get("image"),
  attributes: localizeAttrList([
    ...defaultPageProperties,
    ...metadataPropertiesGroup.properties,
    "image",
    "belonging",
    "belongings",
    "consultation",
    "sekretariat",
    "speciality",
    "faculty",
    "isNavigationPage",
    "altPhoneNumber",
    "altOfficeAddress",
    "altPostalAddress",
    "altEmail",
    "isDeactivated",
    "lastDeactivationDate",
    "pronoun",
  ]),
  properties: [
    "altPhoneNumber",
    "altEmail",
    "altOfficeAddress",
    "altPostalAddress",
    "image",
    "consultation",
    "sekretariat",
    "speciality",
    "faculty",
    "belongings",
    "belonging",
    "hideInNavigation",
    "isNavigationPage",
    "isDeactivated",
    "lastDeactivationDate",
    "pronoun",
    "uid",
  ],
  propertiesGroups: [
    {
      title: "Structured Data (Schema.org)",
      properties: [
        "description",
        "locationName",
        "locationDescription",
        "locationRegion",
        "locationRoom",
        "locationStreet",
        "locationCity",
        "locationPostalCode",
        "locationCountry",
        "locationUrl",
        "postOfficeBoxNumber",
        "addressCountry",
        "addressRegion",
      ],
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    isNavigationPage: "no",
    body: [
      new SectionContentWidget({
        content: [new HeadlineWidget({ style: "h1" })],
      }),
    ],
    title: "Contact",
    isDeactivated: false,
    lastDeactivationDate: null,
    ...metadataInitialContent,
  },
});
